export default (event, params, formData) => {
  params.form_data = formData;
  console.log("[PostHog]: " + event + ": " + JSON.stringify(params));
  if (window.posthog) {
    window.posthog.capture(event, params);
  }
};
